export default {
  messages: [],
  online: 0,
  isProcess: false,
}